export enum SuspiciousRecordReviewActionType {
  ACCEPT = 'ACCEPT',
  REJECT = 'REJECT',
  SKIP = 'SKIP'
}
